// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer-page-height {
    overflow-y: hidden;
}

.customer-datatable-list {
    padding: 30px 30px 0;
}

.customer-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    gap: 10px;
    flex-wrap: wrap;
}

.customer-header .customer-heading {
    font-size: 20px;
    font-weight: 600;
}

.customer-left-side {
    display: flex;
    align-items: center;
    gap: 10px;
}

.customer-left-side .search-bar {
    display: flex;
    align-items: center;
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 8px 12px;
    min-width: 250px;
    height: 40px;
}

.customer-left-side .search-bar img {
    width: 16px;
    height: 16px;
    margin-right: 8px;
}

.customer-left-side .search-bar input {
    border: none;
    outline: none;
    padding: 8px 0;
    width: 100%;
    font-size: 14px;
}

.customer-left-side .search-bar input::placeholder {
    color: #667085;
}



.action-buttons button {
    border-radius: 5px;
    border: none;
    cursor: pointer;
    background-color: var(--white);
    padding: 0;
}

.action-buttons {
    display: flex;
    align-items: center;
    gap: 0 15px;
}

.add-new-user .form-group .form-input {
    padding: 8px 12px;
    gap: 8px;
    height: 45px;
    width: 100%;
    background: #ffffff;
    border: 1px solid #d0d5dd;
    border-radius: 6px;
    outline: none;
    margin-top: 10px;
    margin-bottom: 0;
    font-size: 14px;
    font-family: 'CyGrotesk-KeyRegular';
}

.form-input.description {
    resize: vertical;
    min-height: 100px;
}

.action-buttons-delete-add {
    display: flex;
    align-items: center;
    gap: 0 12px;
}

.delete-selected-btn {
    cursor: pointer;
}

.export-btn {
    width: 167.28px;
    height: 39px;
}

.export-subscriber-btn {
    width: 174.66px;
    height: 39px;
}

.export-btn img {
    width: 16px;
    height: 16px;
}

@media screen and (max-width: 768px) {

    .search-bar,
    .customer-left-side {
        width: calc(100% - 50px);
        min-width: calc(100% - 50px)
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/customer.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,cAAc;IACd,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;;;AAIA;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,8BAA8B;IAC9B,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI;;QAEI,wBAAwB;QACxB;IACJ;AACJ","sourcesContent":[".customer-page-height {\n    overflow-y: hidden;\n}\n\n.customer-datatable-list {\n    padding: 30px 30px 0;\n}\n\n.customer-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.customer-header .customer-heading {\n    font-size: 20px;\n    font-weight: 600;\n}\n\n.customer-left-side {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.customer-left-side .search-bar {\n    display: flex;\n    align-items: center;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    padding: 8px 12px;\n    min-width: 250px;\n    height: 40px;\n}\n\n.customer-left-side .search-bar img {\n    width: 16px;\n    height: 16px;\n    margin-right: 8px;\n}\n\n.customer-left-side .search-bar input {\n    border: none;\n    outline: none;\n    padding: 8px 0;\n    width: 100%;\n    font-size: 14px;\n}\n\n.customer-left-side .search-bar input::placeholder {\n    color: #667085;\n}\n\n\n\n.action-buttons button {\n    border-radius: 5px;\n    border: none;\n    cursor: pointer;\n    background-color: var(--white);\n    padding: 0;\n}\n\n.action-buttons {\n    display: flex;\n    align-items: center;\n    gap: 0 15px;\n}\n\n.add-new-user .form-group .form-input {\n    padding: 8px 12px;\n    gap: 8px;\n    height: 45px;\n    width: 100%;\n    background: #ffffff;\n    border: 1px solid #d0d5dd;\n    border-radius: 6px;\n    outline: none;\n    margin-top: 10px;\n    margin-bottom: 0;\n    font-size: 14px;\n    font-family: 'CyGrotesk-KeyRegular';\n}\n\n.form-input.description {\n    resize: vertical;\n    min-height: 100px;\n}\n\n.action-buttons-delete-add {\n    display: flex;\n    align-items: center;\n    gap: 0 12px;\n}\n\n.delete-selected-btn {\n    cursor: pointer;\n}\n\n.export-btn {\n    width: 167.28px;\n    height: 39px;\n}\n\n.export-subscriber-btn {\n    width: 174.66px;\n    height: 39px;\n}\n\n.export-btn img {\n    width: 16px;\n    height: 16px;\n}\n\n@media screen and (max-width: 768px) {\n\n    .search-bar,\n    .customer-left-side {\n        width: calc(100% - 50px);\n        min-width: calc(100% - 50px)\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
